// paypal-paylater.js

document.addEventListener('DOMContentLoaded', function () {

  // Helper: render PayPal Pay Later message
  function renderPayLater() {
    const messageDiv = document.querySelector('[data-pp-message]');
    if (!messageDiv || !window.paypal || !paypal.Messages) return;

    // Clear old content
    messageDiv.innerHTML = '';

    // Use current price from data attribute
    const amount = parseFloat(messageDiv.dataset.ppAmount);
    paypal.Messages().render(messageDiv, { amount });
  }

  // Initial render on page load
  renderPayLater();

  // Re-render when variants change (Dawn-style or similar)
  const variantSelectors = document.querySelectorAll('input[name="id"], select[name="id"]');
  variantSelectors.forEach(function (input) {
    input.addEventListener('change', function () {
      const selectedVariantPrice = window.variantPrice || null;

      const messageDiv = document.querySelector('[data-pp-message]');
      if (messageDiv && selectedVariantPrice) {
        messageDiv.dataset.ppAmount = selectedVariantPrice;
      }

      renderPayLater();
    });
  });

  // Optional: Observe price container if theme updates dynamically (for swatches/radios)
  const priceContainer = document.querySelector('.product__price, .price__regular, .price');
  if (priceContainer) {
    const observer = new MutationObserver(function () {
      const priceText = priceContainer.textContent.replace(/[^0-9.]/g, '');
      if (priceText) {
        const messageDiv = document.querySelector('[data-pp-message]');
        if (messageDiv) {
          messageDiv.dataset.ppAmount = parseFloat(priceText);
          renderPayLater();
        }
      }
    });
    observer.observe(priceContainer, { childList: true, subtree: true, characterData: true });
  }
});
